import { Auth } from 'aws-amplify'
import { getProgramData, showBuildingPicker } from '../redux/app/actions'
import { StorageService } from './StorageService'
import history from '../History'

export const setCurrentBuilding = (data) => {
    StorageService.set('currentBuilding', data)
    Auth.currentAuthenticatedUser().then((user) => {
        getProgramData(data, user)
        showBuildingPicker(false)
        history.push('/')
    })
}
